/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const nativeAuthTokenResponseExpiresInExclusiveMin = 0;

export const NativeAuthTokenResponse = zod.object({
  access_token: zod.string(),
  client_id: zod
    .string()
    .optional()
    .describe(
      'The Ory OAuth2 client the tokens were minted for. Refresh and revoke them at Ory with this client_id.',
    ),
  expires_in: zod.int().gt(nativeAuthTokenResponseExpiresInExclusiveMin),
  id_token: zod.string().optional(),
  refresh_token: zod.string(),
  token_type: zod.string(),
});

export type NativeAuthTokenResponse = zod.input<typeof NativeAuthTokenResponse>;
export type NativeAuthTokenResponseOutput = zod.output<typeof NativeAuthTokenResponse>;
